module.exports = __webpack_public_path__ + "media/budapest/heroes_square-68de904a.jpg";